import React, { Component } from "react";
import { Row, Col } from "antd";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        column: "name",
        status: "pending",
        search: "",
        totalCount: 0,
        currentCount: 0,
        total_pages: 0,
      },
    };
  }
  componentDidMount() {
    const { getOrders, getUserDetails } = this.props;

    const companyId = this.props.user?.[1]?.contractor?.id;

    if (companyId) {
      getOrders(companyId, this.state.filter);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getCounts, getOrders, getUserDetails } = this.props;

    const id = this.props.user?.[1]?.contractor?.id;
    if (preProps.user[0] !== this.props.user[0]) {
      getOrders(id, this.state.filter);
    }

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search ||
      preState.filter.status !== this.state.filter.status
    ) {
      getOrders(id, this.state.filter);
    }
  }

  onChangeTab = (key) => {
    const { getOrders } = this.props;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "pending",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "pending" });
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "inprogress",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "inprogress" });
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          status: "completed",
        },
      });
      getOrders(companyId, { ...this.state.filter, status: "completed" });
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };
  render() {
    return (
      <Row>
        <Col span={24} style={{ marginBottom: "80px" }}>
          <PlantOrder
            {...this.props}
            onChangeTab={this.onChangeTab}
            metaData={this.state.filter}
            currentPage={this.currentPage}
            previousPage={this.previousPage}
            onChangeText={this.onChangeText}
            searchValue={this.state.filter.search}
            onClearSearch={() =>
              this.setState({
                filter: {
                  ...this.state.filter,
                  search: "",
                },
              })
            }
          />
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    Orders: store.DashboardReducer.orders,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    isLoader: store.DashboardReducer.isOrder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getOrders: (id, params) =>
      dispatch(DashboardAction.getOrderReq(id, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MyOrders);
